$(document).ready(function () {
  
    var presswidth = $('.initial-width').width();

    document.querySelector(".press-ticker-inner").animate(
        [
            { transform: 'translateX(0)' }, 
            { transform: `translateX(-${presswidth}px)` }
        ],
        {
            duration: 110000,
            iterations: Infinity
          }
      );
});